<mat-table [dataSource]="dataTable.dataSource" mat-table matSort>
  <ng-container matColumnDef="id">
    <th *matHeaderCellDef mat-header-cell>#</th>
    <td *matCellDef="let i = index" mat-cell>
      {{ paginator.pageIndex == 0 ? i + 1 : 1 + i + paginator.pageIndex * paginator.pageSize }}
    </td>
  </ng-container>
  <ng-container *ngFor="let column of dataTable.displayedColumn" matColumnDef="{{column}}">
    <th *matHeaderCellDef mat-header-cell>{{ column }}</th>
    <td *matCellDef="let element" mat-cell>{{ element[column] }}</td>
  </ng-container>

  <tr *matHeaderRowDef="dataTable.displayedColumn" mat-header-row></tr>
  <tr *matRowDef="let row; columns: dataTable.displayedColumn;" mat-row></tr>
</mat-table>

<mat-paginator #paginator
               [pageSizeOptions]="dataTable.sizeOption"
               aria-label="Select page">
</mat-paginator>
